/**
 * CJA Analytics configuration for the UBT Tracker application.
 *
 * Page names follow the KP naming convention:
 * kporg:en:nat:mykp:ubt:<section>[:<feature>][:<detail>]
 */

export const ANALYTICS_CONFIG = {
  /** Root prefix shared by every page name in the UBT application. */
  BASE_PAGE_NAME: 'kporg:en:nat:mykp:ubt',

  /** Application identifier used in site.applicationName. */
  APPS: {
    UBT: 'ubt',
  },

  /**
   * Fully-qualified page names for every route in App.tsx.
   * Values are *relative* to BASE_PAGE_NAME and are joined by getFullPageName().
   */
  PAGES: {
    HOME:                'home',
    MY_TEAMS:            'my-teams',
    PROJECTS:            'projects',
    HISTORY:             'history',
    CONTACT_US:          'contact-us',
    SELECT_UBT:          'select-ubt',
    MEMBERS:             'members',
    ADD_PROFILE:         'add-profile',
    EDIT_UBT:            'edit-ubt',
    MANAGE_ACCESS:       'manage-access',
    MANAGE_ACCESS_ADD:   'manage-access:add-access',
    SEARCH_PROJECTS:     'search-projects',
    PATH_TO_PERFORMANCE: 'path-to-performance',
    TEAMS_REPORTING:     'teams-reporting',
    TEAM_DOCUMENTS:      'team-documents',
    TEST_DATA_CHARTS:    'test-data-charts',
    NOT_FOUND:           'error:not-found',
  },

  /** Adobe Launch event names that CJA rules listen for. */
  EVENTS: {
    PAGE_VIEW:    'cjaCustomPageview',
    BUTTON_CLICK: 'buttonClick',
    SEARCH:       'search',
  },
} as const;

/**
 * Builds a fully-qualified KP page name from a relative page segment.
 *
 * @param pageKey - Relative segment (a value from ANALYTICS_CONFIG.PAGES)
 * @returns Full page name, e.g. "kporg:en:nat:mykp:ubt:home:my-teams"
 */
export const getFullPageName = (pageKey: string): string =>
  `${ANALYTICS_CONFIG.BASE_PAGE_NAME}:${pageKey}`;
